import React from 'react'

const PaymentIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="42.7" height="42" viewBox="0 0 61 60" {...props}>
    <circle cx="30.185" cy="30" r="30" fill="#DA291C" />

    <g
      clipPath="url(#clip0)"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none">
      <path d="M37.31 28.5a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z" />
      <path d="M22.685 37.5h-3c-.199 0-.39-.079-.53-.22a.75.75 0 0 1-.22-.53V33c0-.199.079-.39.22-.53.14-.141.331-.22.53-.22h3" />
      <path d="M28.685 33h3l6.281-1.445a1.5 1.5 0 0 1 .74 2.892L35.435 36l-6 1.5h-6.75v-5.25l2.344-2.344a2.25 2.25 0 0 1 1.593-.656h4.687a1.875 1.875 0 0 1 0 3.75h-2.625Z" />
      <path d="M34.685 25.996a3.001 3.001 0 1 1 1.5-2.492" />
    </g>

    <defs>
      <clipPath id="clip0">
        <rect
          width="24"
          height="24"
          transform="translate(18.185 18)"
          fill="#fff"
        />
      </clipPath>
    </defs>
  </svg>
)

export default PaymentIcon
